import { Mail, Phone, Info } from "lucide-react";
import ContactFormComponent from "./ContactFormComponent";

const ContactSection = () => {
  return (
    <section id="contact" className="py-20 sm:py-28 bg-white">
      <div className="section-container">
        <h2 className="section-title">Contact PSAOA</h2>
        <p className="section-subtitle">
          Get in touch with the association management
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {/* Contact Form - Takes 2 columns on large screens */}
          <div className="lg:col-span-2">
            <ContactFormComponent />
          </div>

          {/* Contact Info - Right sidebar */}
          <div className="space-y-6">
            {/* Email */}
            <div className="bg-gradient-to-br from-white to-slate-50 border border-slate-200 rounded-lg p-6 hover:shadow-lg transition-all">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-blue-100 rounded-lg">
                  <Mail className="w-6 h-6 text-blue-600" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-1">
                    Email
                  </p>
                  <a
                    href="mailto:office.psaoa@gmail.com"
                    className="text-sm font-bold text-blue-600 hover:text-blue-700 transition-colors break-all"
                  >
                    office.psaoa@gmail.com
                  </a>
                  <p className="text-xs text-muted-foreground mt-2">
                    For official communication
                  </p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="bg-gradient-to-br from-white to-slate-50 border border-slate-200 rounded-lg p-6 hover:shadow-lg transition-all">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-blue-100 rounded-lg">
                  <Phone className="w-6 h-6 text-blue-600" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-1">
                    Office Phone
                  </p>
                  <a
                    href="tel:8838907864"
                    className="text-sm font-bold text-blue-600 hover:text-blue-700 transition-colors"
                  >
                    88389 07864
                  </a>
                  <p className="text-xs text-muted-foreground mt-2">
                    10:30 AM - 6:00 PM
                  </p>
                </div>
              </div>
            </div>

            {/* Office Hours */}
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6">
              <h3 className="font-bold text-sm text-foreground mb-3 uppercase tracking-wide">Office Hours</h3>
              <p className="text-slate-700 text-sm font-semibold mb-1">
                10:30 AM to 6:00 PM
              </p>
              <p className="text-xs text-slate-600">
                (Or as decided by the Executive Committee)
              </p>
            </div>

            {/* Address */}
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6">
              <h3 className="font-bold text-sm text-foreground mb-3 uppercase tracking-wide">Office Address</h3>
              <div className="text-slate-700 text-xs leading-relaxed space-y-1">
                <div>Purva Swanlake</div>
                <div>1/367 A, Renugambal Nagar</div>
                <div>OMR Road, Kelambakkam</div>
                <div>Chengalpattu District</div>
                <div>Tamil Nadu - 603103</div>
              </div>
            </div>
          </div>
        </div>

        {/* Info Box */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 flex items-start gap-4">
          <Info className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-blue-900 mb-1">How We Process Your Inquiry</p>
            <p className="text-blue-800 text-sm">
              All inquiries submitted through this form are automatically saved and a notification is sent to our management team. 
              We typically respond within 24 hours during business hours. For urgent matters, please call our office directly.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
